import { render, staticRenderFns } from "./Mandate.vue?vue&type=template&id=305de8db"
import script from "./Mandate.vue?vue&type=script&lang=js"
export * from "./Mandate.vue?vue&type=script&lang=js"
import style0 from "./Mandate.vue?vue&type=style&index=0&id=305de8db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports